import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { Badge, Button, Col, Row, Stack } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { motion } from 'framer-motion'
import { useLocation } from 'react-router-dom'

const logoBase = `${process.env.PUBLIC_URL}/images/logo-rgw`

const Header = () => {

  return (
    <div  className='mt-4'>
      <Row className='page-head'>
          <Col lg={8} sm={12}>
              <Link to={'/'} className='justify-content-center' aria-label="Reggae Wheels home">
                <motion.img
                  width={110}
                  height={56}
                  src={`${logoBase}-110.webp`}
                  srcSet={`${logoBase}-110.webp 1x, ${logoBase}-220.webp 2x`}
                  alt="Reggae Wheels"
                  initial = {{scale: 0.65, x: '45vw', y: '-3vh' }}
                  animate = {{ scale: 1, x: 0, y: 0 }}
                  transition = {{ delay: 0.2, duration: 1.85 }}
                />
              </Link>  
          </Col>
          <Col className='par-signin'>
              <IsLoggedIn />
          </Col>
        </Row>
    </div>
  )
}

function IsLoggedIn(){
    const { currentUser, logout, userRole, userName } = useAuth();

    const location = useLocation();

    function handleLogout(){
      logout();
    }
  
    if(currentUser){
      return (<Stack className='logged-in align-bottom' direction='horizontal' gap={4}>
      <Stack className='align-bottom' gap={0} direction='vertical'> 
        {userRole && userRole === "Administrator" ? 
          (<Badge className='small' variant={'primary'}>{userRole}</Badge>)
        : ''
        }
        <div className='bk-dark translucent rounded-2'>
          <h5 className='text-center'><small>Welcome Back {userName ? userName : currentUser.email}</small></h5>
        </div>
      </Stack>
      <Button className='btn-sm' variant='danger' onClick={handleLogout}>Log Out</Button>
      </Stack>) 
    }
  
  return (
    <div className='lg-login'>
      <Stack className='align-bottom justify-content-end head-login' direction='horizontal' gap={3}>
              <Link className={location.pathname === "/" ? 'btn btn-sm bt-dark text-bold pull-right' : 'btn btn-sm bt-mint pull-right'} to="/signup">Sign Up</Link>
              <Link className='btn btn-sm bt-cream clear pull-right' to="/login">Log In</Link>
      </Stack>
    </div>)
}

export default memo(Header);
